<template>
  <span
    class="base-badge"
    :class="badgeClasses"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'BaseBadge',
  props: {
    type: {
      /* Accepted values: 'green', 'orange', 'gray' */
      type: String,
      required: true,
    },
  },
  computed: {
    badgeClasses() {
      return `base-badge--${this.type}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-badge {
  font-size: 12px;
  line-height: 130%;
  font-family: $font-family-sans-serif-semibold;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding-inline: 0 !important;
  &--green {
    color: $strong-green;
  }
  &--orange {
    color: $bright-orange;
  }
  &--gray {
    color: $gray;
  }
}
</style>
